export { useInitGTM } from './hooks';
